module.exports = __webpack_public_path__ + "src/shared-components/icons/checkmark.9195610bfd6d1194634c4b29658f2aa4.svg";